// import { useEffect, useRef, useState } from 'react';

// function useOnScreen(options = {}) {
//   const ref = useRef();
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(([entry]) => {
//       setIsVisible(entry.isIntersecting);
//     }, options);

//     if (ref.current) {
//       observer.observe(ref.current);
//     }

//     return () => {
//       if (ref.current) {
//         observer.unobserve(ref.current);
//       }
//     };
//   }, [ref, options]);

//   return [ref, isVisible];
// }

// export default useOnScreen;

import { useEffect, useRef, useState } from 'react';

function useOnScreen(options = {}) {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        try {
          observer.unobserve(ref.current);
        } catch (error) {
          console.warn('Observer cleanup failed:', error);
        }
      }
    };
  }, [ref, options]);

  return [ref, isVisible];
}

export default useOnScreen;
